import React from 'react';

const WEATHER_OPTIONS = [
  { id: 'stormy', icon: '🌩', label: 'Stormy', response: "Storms pass. You don't have to weather this one alone." },
  { id: 'heavy', icon: '🌧', label: 'Heavy', response: "Heavy days ask us to move slowly. That's wisdom, not weakness." },
  { id: 'cloudy', icon: '⛅', label: 'Somewhere in between', response: "In between is a valid place to be. You don't have to know yet." },
  { id: 'lifting', icon: '🌤', label: 'Lifting', response: "Something is shifting. Your body knows before your mind does." },
  { id: 'grounded', icon: '☀️', label: 'Grounded', response: "Grounded days are sacred. Let yourself receive this one." },
];

export const EmotionalWeather = ({ 
  selectedWeather, 
  weatherResponse, 
  onWeatherSelect, 
  animateIn 
}) => {
  return (
    <section 
      className={`mb-10 transition-all duration-700 ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: '0.2s' }}
    >
      <h2 
        className="text-xs tracking-[0.2em] mb-6 text-center"
        style={{ 
          fontFamily: 'Jost, sans-serif',
          color: '#C9A84C'
        }}
      >
        HOW ARE YOU ARRIVING TODAY?
      </h2>
      
      <div className="flex justify-center gap-4 mb-6">
        {WEATHER_OPTIONS.map((weather) => (
          <button
            key={weather.id}
            onClick={() => onWeatherSelect(weather)}
            className="flex flex-col items-center transition-all duration-300"
            data-testid={`weather-${weather.id}`}
          >
            <div 
              className={`w-12 h-12 rounded-full flex items-center justify-center text-xl mb-2 transition-all duration-300 ${
                selectedWeather === weather.id ? 'scale-110' : 'hover:scale-105'
              }`}
              style={{ 
                background: selectedWeather === weather.id 
                  ? 'radial-gradient(circle, rgba(201,168,76,0.4) 0%, rgba(201,168,76,0.1) 100%)'
                  : 'radial-gradient(circle, rgba(232,180,184,0.15) 0%, rgba(232,180,184,0.05) 100%)',
                boxShadow: selectedWeather === weather.id 
                  ? '0 0 20px rgba(201,168,76,0.4)' 
                  : 'none',
              }}
            >
              {weather.icon}
            </div>
            <span 
              className="text-xs transition-colors duration-300"
              style={{ 
                fontFamily: 'Jost, sans-serif',
                color: selectedWeather === weather.id ? '#C9A84C' : '#8A8798'
              }}
            >
              {weather.label}
            </span>
          </button>
        ))}
      </div>
      
      {/* Weather Response */}
      {weatherResponse && (
        <div 
          className="text-center p-4 rounded-xl animate-fade-in"
          style={{ 
            background: 'rgba(201,168,76,0.08)',
            border: '1px solid rgba(201,168,76,0.2)'
          }}
        >
          <p 
            className="text-sm italic"
            style={{ 
              fontFamily: 'Playfair Display, serif',
              color: '#4A4A5A'
            }}
          >
            "{weatherResponse}"
          </p>
        </div>
      )}
    </section>
  );
};

export { WEATHER_OPTIONS };
